import { idealCandidateSectionID } from './IdealCandidate';
import { screeningQuestionsSectionID } from './ScreeningQuestions';

export const MANDATORY_GENERATED_SECTION_TITLES = ['Overview', 'Scope of work'];

export const GENERATED_CONTENT_EXCLUDED_SECTION_IDS = [idealCandidateSectionID, screeningQuestionsSectionID];
